import type { RoadmapDetailCoursesItem } from './roadmapDetailCoursesItem';
import type { RoadmapDetailSummary } from './roadmapDetailSummary';

export interface RoadmapDetail {
  /**
   * 로드맵 상세 내용 (Markdown 등)
   * @nullable
   */
  content?: string | null;
  /**
   * 로드맵에 포함된 강의 목록
   * @nullable
   */
  courses: RoadmapDetailCoursesItem[] | null;
  /** 로드맵 기본 요약 정보 */
  summary: RoadmapDetailSummary;
}
